module.exports = __webpack_public_path__ + "img/05.87cf5c6d.png";